import { Button } from '@chronosphereio/chrono-ui';
import { PencilOutline as PencilIcon } from 'mdi-material-ui';

export interface EditButtonProps {
  /**
   * The label used inside the button.
   */
  label?: string;

  /**
   * Handler that puts the dashboard into editing mode.
   */
  onClick: () => void;
}

export const EditButton = ({ label = 'Edit', onClick }: EditButtonProps) => {
  return (
    <Button
      onClick={onClick}
      StartIcon={<PencilIcon />}
      variant="secondary"
      sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
    >
      {label}
    </Button>
  );
};
